import { render, staticRenderFns } from "./ProgressoOrdine.vue?vue&type=template&id=20df3d3e&scoped=true"
import script from "./ProgressoOrdine.vue?vue&type=script&lang=ts"
export * from "./ProgressoOrdine.vue?vue&type=script&lang=ts"
import style0 from "./ProgressoOrdine.vue?vue&type=style&index=0&id=20df3d3e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df3d3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20df3d3e')) {
      api.createRecord('20df3d3e', component.options)
    } else {
      api.reload('20df3d3e', component.options)
    }
    module.hot.accept("./ProgressoOrdine.vue?vue&type=template&id=20df3d3e&scoped=true", function () {
      api.rerender('20df3d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProgressoOrdine.vue"
export default component.exports